import styled from "styled-components";
import { Card, Button, Typography } from "antd";
import { StyledButton } from "../../components/styles";
import CustomTable from "../../components/CustomTable";
const { Title } = Typography;

export const WhiteboardCard = styled(Card)`
  border-radius: 8px;
`;

export const ActionButton = styled(Button)`
  margin: 0 4px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const ContentContainer = styled.div`
  padding: 0;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: rgba(0, 0, 0, 0.45);
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

export const MessageContent = styled.div`
  white-space: pre-line;
  max-width: 300px;
  word-break: break-word;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 16px;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
  
  h4 {
    margin-bottom: 0;
  }
  
  button {
    white-space: nowrap;
    
    @media (max-width: 576px) {
      width: 100%;
    }
  }
`;

export const WhiteboardContainer = styled.div`
  padding: 24px;
  gap: 16px;
  height: calc(100vh - 150px);
  overflow: hidden;
  /* overflow-x: scroll; */
  /* 
  @media (max-width: 1435px) {
    height: calc(100vh - 193px);
  }

  @media (max-width: 700px) {
    height: calc(100vh - 305px);
  } */
`;
export const TableWrapper = styled.div`
  height: calc(100vh - 200px);
  overflow-x: scroll;
`;
export const TableStyles = styled.div`
  .styled-table .ant-table-thead > tr > th {
    background-color: #f0f2f5;
    font-weight: 600;
  }

  .styled-table .ant-table-tbody > tr > td {
    vertical-align: top;
  }

  .message-cell {
    white-space: pre-line;
    max-width: 300px;
    word-break: break-word;
  }
`;

export const TableActionButton = styled(StyledButton)`
  margin: 0 4px;
  padding: 4px 8px;
  height: auto;
  min-width: auto;
`;

export const WhiteboardStyledTable = styled(CustomTable)`
    .ant-table-tbody > tr > td {
      padding: 8px 16px;
    }
`;

export const WhiteTitle = styled(Title)`
  margin: 0 !important;
  padding: 0;
`;